import { Injectable, Output, EventEmitter } from '@angular/core';
import { NotificationAccess } from '@edassist/api';

@Injectable({ providedIn: 'root' })
export class NotificationAlertIndicatorService {
	@Output() readonly announcementAndAdminMsgCountEvent: EventEmitter<number> =
		new EventEmitter();
	@Output() readonly isLoadingEvent: EventEmitter<boolean> = new EventEmitter();
	@Output() readonly unreadNotificationCountEvent: EventEmitter<number> =
		new EventEmitter();
	@Output()
	readonly notificationAccessedEvent: EventEmitter<NotificationAccess> =
		new EventEmitter();

	notifyAnnouncementAndAdminMsgCount(
		announcementAndAdminMsgCount: number
	): void {
		this.announcementAndAdminMsgCountEvent.emit(announcementAndAdminMsgCount);
	}

	notifyUnreadNotificationCount(unreadNotificationCount: number): void {
		this.unreadNotificationCountEvent.emit(unreadNotificationCount);
	}

	notificationAccessed(notificationAccessed: NotificationAccess): void {
		this.notificationAccessedEvent.emit(notificationAccessed);
	}
}
